import { useTranslation } from 'react-i18next';
import { Button } from '@ui/components';

import { NotificationsBulkDeleteDialog } from './notifications-bulk-delete-dialog/notifications-bulk-delete-dialog';
import { useNotificationsBulkActions } from './use-notifications-bulk-actions';

export const NotificationsBulkActions = ({
  onNotificationMarkAsRead,
  onNotificationRemove,
  selectedRows,
}: {
  onNotificationMarkAsRead: () => void;
  onNotificationRemove: () => void;
  selectedRows: string[];
}) => {
  const { t } = useTranslation();

  const {
    isDeleteOpen,
    isPendingDelete,
    bulkEditEmployeesDeleteMutation,
    bulkEditEmployeesMarkAsReadMutation,
    setIsDeleteOpen,
    isPendingMarkAsRead,
  } = useNotificationsBulkActions({
    onNotificationMarkAsReadSuccess: onNotificationMarkAsRead,
    onNotificationRemoveSuccess: onNotificationRemove,
  });

  return (
    <div className="flex items-center gap-1 mb-2 px-1">
      <NotificationsBulkDeleteDialog
        onRemove={() => bulkEditEmployeesDeleteMutation(selectedRows)}
        onClose={() => setIsDeleteOpen(false)}
        isPending={isPendingDelete}
        isOpen={isDeleteOpen}
      />

      <Button
        onClick={() => bulkEditEmployeesMarkAsReadMutation(selectedRows)}
        isLoading={isPendingMarkAsRead}
        disabled={isPendingMarkAsRead}
        variant="ghost"
      >
        {t('NOTIFICATIONS.BULK_MARK_AS_READ')}
      </Button>
    </div>
  );
};
